import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCategoriesDataView,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import Link from "@insite/mobius/Link";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Typography from "@insite/mobius/Typography";
import Group from "@midland-industries/Components/Group";
import CategoryCard from "@midland-industries/Components/HomePage/CategoryCard";
import Stack from "@midland-industries/Components/Stack";
import { colors } from "@midland-industries/Styles/colors";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const getCategoriesParameter = {
        maxDepth: 1,
        includeStartCategory: false,
    };
    return {
        categoriesDataView: getCategoriesDataView(state, getCategoriesParameter),
        getCategoriesParameter,
        topLevelCategoryIds: getSubCategoryIds(state, emptyGuid),
    };
};

const mapDispatchToProps = {
    loadCategories,
};

type PopularCategoriesProps = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const PopularCategories: React.FC<PopularCategoriesProps> = ({
    categoriesDataView,
    getCategoriesParameter,
    topLevelCategoryIds,
    loadCategories,
}) => {
    useEffect(() => {
        if (!categoriesDataView.isLoading && !categoriesDataView.value) {
            loadCategories(getCategoriesParameter);
        }
    }, []);

    return (
        <Stack gap={24}>
            <Group justify="space-between">
                <Typography size={24} color={colors.textAccent} transform="uppercase">
                    Popular Categories
                </Typography>
                <Link href="/Categories" color={colors.textLink}>
                    View all categories
                </Link>
            </Group>
            {categoriesDataView.isLoading ? (
                <Stack align="center" justify="center" style={{ height: "100%" }}>
                    <LoadingSpinner color={colors.border} />
                </Stack>
            ) : (
                <Group wrap gap={14} style={{ minHeight: 380 }}>
                    {topLevelCategoryIds?.slice(0, 11).map(categoryId => (
                        <CategoryCard key={categoryId} categoryId={categoryId} />
                    ))}
                </Group>
            )}
        </Stack>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PopularCategories);
